export const config = {
  title: 'J&D Contractor Services LLC | Electrical and Construction Services in VA',
  meta: {
    description:
      'J&D Contractor Services LLC is your trusted electrical and construction partner in North Chesterfield, VA. We specialize in residential and commercial projects, including EV charging stations, lighting fixture installations, and electrical inspections.',
    keywords: [
      'Electrical Services',
      'Construction Services',
      'EV Charging Installation',
      'Lighting Installation',
      'Electrical Inspections',
      'J&D Contractor Services LLC',
      'North Chesterfield VA',
    ],
    author: 'J&D Contractor Services LLC',
    canonicalUrl: 'https://www.jdcontractorservicesllc.com/',
  },
  sections: {
    header: {
      businessName: 'J&D Contractor Services LLC',
    },
    sectionB: {
      heroTitle: 'J&D Contractor Services LLC',
      heroSubtitle: 'Building Trust, Delivering Excellence in North Chesterfield, VA',
      learnAboutText: 'Explore Services',
      phoneNumber: '8049041158',
      phoneLabel: '(804) 904-1158',
      heroBackgroundImage:
        'https://media.istockphoto.com/id/918746438/photo/construction-residential-new-house-in-progress-at-building-site.jpg?s=612x612&w=0&k=20&c=o66U2sJO45ZgQ6gur4UKVqolyjb-cdXb8RC2PfenSo8=',
      cardData: [
        {
          title: 'High-Quality Workmanship',
          description:
            'Our team ensures that every project is executed with precision and care, meeting and exceeding client expectations.',
        },
        {
          title: 'Tailored Solutions',
          description:
            'We provide custom construction and electrical solutions designed to match your specific needs and vision.',
        },
        {
          title: 'Reliable Support',
          description:
            'Our commitment to transparency and open communication makes your project journey seamless and worry-free.',
        },
      ],
      description:
        'J&D Contractor Services LLC offers comprehensive electrical and construction services to meet all your residential and commercial needs in North Chesterfield, VA.',
    },
    sectionC: {
      servicesTitle: 'Our Services',
      servicesDescription:
        'At J&D Contractor Services LLC, we offer a wide range of services to ensure your construction and electrical projects are handled with expertise and precision.',
      cards: [
        {
          title: 'Installation of Charging Stations for Electric Vehicles',
          description:
            'Professional installation of EV charging stations for your home or business.',
          imageSrc:
            'https://www.jdcontractorservicesllc.com/wp-content/uploads/2025/01/Installation-of-charging-stations-for-electric-vehicles.png',
          imageAlt: 'EV Charging Installation',
        },
        {
          title: 'Installation of Lighting Fixtures',
          description:
            'Upgrade your space with stylish and functional lighting fixtures.',
          imageSrc:
            'https://www.jdcontractorservicesllc.com/wp-content/uploads/2025/01/INSTALLATION-OF-LIGHTING-FIXTURES.png',
          imageAlt: 'Lighting Fixture Installation',
        },
        {
          title: 'Electrical Inspections',
          description:
            'Comprehensive electrical inspections to ensure safety and compliance.',
          imageSrc:
            'https://www.jdcontractorservicesllc.com/wp-content/uploads/2025/01/ELECTRICAL-INSPECTIONS.png',
          imageAlt: 'Electrical Inspections',
        },
      ],
      otherServicesTitle: 'Other Services',
      otherServicesList: [
        'Relocation/Installation of Outlets & Switches',
        'Repair of Electric Panels',
        'Replacement or Upgrade of Electrical Panels',
        'Restoration of Electrical Power Supply',
        'Installation of Security Systems',
        'Installation and Repair of Lighting Fixtures',
      ],
    },
    sectionD: {
      aboutTitle: 'About Us',
      aboutImage: {
        src: 'https://www.jdcontractorservicesllc.com/wp-content/uploads/2025/01/MASTER-5.jpg',
        alt: 'J&D Contractor Services LLC Team',
      },
      aboutText: [
        'At J&D Contractor Services LLC, we are committed to providing top-tier solutions for all your electrical and construction needs. Whether you’re looking for residential or commercial services, our skilled team ensures every project is handled with professionalism, safety, and unmatched quality.',
        'With years of experience, we have become a trusted name in the industry, offering customized services tailored to meet your unique requirements. From small repairs to large-scale renovations, we deliver exceptional results that exceed expectations. Trust J&D Contractor Services LLC to bring reliability, expertise, and excellence to every project. Your satisfaction is our priority!',
      ],
    },
    sectionE: {
      profileImage: null,
      profileAlt: 'J&D Contractor Services LLC Logo',
      businessName: 'J&D Contractor Services LLC',
      contact: {
        phone: '8049041158',
        phoneLabel: '(804) 904-1158',
        email: 'jdcontractor1012@gmail.com',
        website: 'https://www.jdcontractorservicesllc.com/',
        address: '735 Hartford LN, North Chesterfield, VA 23236',
      },
      socialMedia: {
        googlePlus: null,
        linkedIn: null,
        facebook: null,
        twitter: null,
        tiktok: null,
        instagram: null,
        youtube: null,
      },
    },
    sectionF: {
      address: '735 Hartford LN, North Chesterfield, VA 23236',
      googleMapsEmbedUrl:
        'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3058.5760110136727!2d-75.16522188467577!3d39.952583979423!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zMznCsDU3JzA5LjMiTiA3NcKwMDknNTguNCJX!5e0!3m2!1sen!2sph!4v1614123456789!5m2!1sen!2sph',
    },
  },
};

export default config;
